import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  items: [],
  loading: false,
  error: null,
};

const solutionProposalsSlice = createSlice({
  name: "solutionProposals",
  initialState,
  reducers: {
    fetchSolutionProposalsRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchSolutionProposalsSuccess: (state, action) => {
      state.loading = false;
      state.items = action.payload;
    },
    fetchSolutionProposalsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    createSolutionProposalRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    createSolutionProposalSuccess: (state, action) => {
      state.loading = false;
      state.items.push(action.payload);
    },
    createSolutionProposalFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    updateSolutionProposalRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    updateSolutionProposalSuccess: (state, action) => {
      state.loading = false;
      const index = state.items.findIndex((p) => p.id === action.payload.id);
      if (index !== -1) {
        state.items[index] = action.payload;
      }
    },
    updateSolutionProposalFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    deleteSolutionProposalRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    deleteSolutionProposalSuccess: (state, action) => {
      state.loading = false;
      state.items = state.items.filter((p) => p.id !== action.payload);
    },
    deleteSolutionProposalFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchSolutionProposalsRequest,
  fetchSolutionProposalsSuccess,
  fetchSolutionProposalsFailure,
  createSolutionProposalRequest,
  createSolutionProposalSuccess,
  createSolutionProposalFailure,
  updateSolutionProposalRequest,
  updateSolutionProposalSuccess,
  updateSolutionProposalFailure,
  deleteSolutionProposalRequest,
  deleteSolutionProposalSuccess,
  deleteSolutionProposalFailure,
} = solutionProposalsSlice.actions;

export default solutionProposalsSlice.reducer;